
<div class="window-container">
  <div class="window-toolbar-padding">
    <div class="window-toolbar flex-grow-row" [id]="'window-toolbar-0'">
      <p class="tps-title">KMU LOGO</p>
      <p style="width: 24px;"></p>

      <tps-window-tabs data-testid="main-layout-window-tabs" [windowIndex]="0" [dropListID]="windowTabsDropListIDs()[0]" [connectedDropLists]="allDropListIDs()" [id]="'window-tabs-0'" [style]="tabBarLimits()[0] > 0 ? 'max-width: ' + tabBarLimits()[0] + 'px;' : ''" />

        <div class="flex-grow-row"></div>
    </div>
  </div>
  <div class="navbar-content-split">

    <div class="main-menu">
      <nav class="navigation">
        @if (route().startsWith('customer/') && route().length > 9) {
          <tps-customer-navbar style="width: 100%" [route]="route()" [customerID]="route().substring(9, 45)" />
        } @else if (route().startsWith('order/')) {
          <tps-manufacturing-order-navbar style="width: 100%" [route]="route()" [orderID]="route().substring(6, 42)" />
        } @else if (route().startsWith('article/')) {
          <tps-article-navbar style="width: 100%" [route]="route()" [articleID]="route().substring(8, 44)" />
        } @else {
          <tps-windowed-router-link data-testid="main-layout-nav-open-dashboard" [url]="''" [tabLabel]="i18n.translate('dashboard')">
            <tps-navbar-button matIcon="dashboard" [label]="i18n.translate('dashboard')()" tabType="none" />
          </tps-windowed-router-link>

          <tps-navbar-button disabled matIcon="timeline"  [label]="i18n.translate('timeline')()" tabType="none" />

          <div class="separator-h"></div>
          <div class="group-title">{{ i18n.translate('modules')() }}</div>

          @if (state.basedataExpanded()) {
            <tps-navbar-button data-testid="main-layout-nav-toggle-basedata" (click)="state.basedataExpanded.set(false)" matIcon="folder_open" [label]="i18n.translate('basedata')()" tabType="none" arrow="keyboard_arrow_down" />
          } @else {
            <tps-navbar-button data-testid="main-layout-nav-toggle-basedata" (click)="state.basedataExpanded.set(true)" matIcon="folder" [label]="i18n.translate('basedata')()" tabType="none" arrow="keyboard_arrow_left" />
          }
          @if (state.basedataExpanded()) {
            <tps-windowed-router-link data-testid="main-layout-nav-open-customers" [url]="'/customer'" [tabLabel]="i18n.translate('customers')">
              <tps-navbar-button matIcon="factory_filled" [label]="i18n.translate('customers')()" tabType="none" [indentation]="1" />
            </tps-windowed-router-link>
            <tps-windowed-router-link data-testid="main-layout-nav-open-manufacturing-orders" [url]="'/order'" [tabLabel]="i18n.translate('manufacturingOrders')">
              <tps-navbar-button matIcon="note_alt_filled" [label]="i18n.translate('manufacturingOrders')()" tabType="none" [indentation]="1" />
            </tps-windowed-router-link>
            <tps-windowed-router-link data-testid="main-layout-nav-open-articles" [url]="'/article'" [tabLabel]="i18n.translate('articles')">
              <tps-navbar-button matIcon="view_in_ar" [label]="i18n.translate('articles')()" tabType="none" [indentation]="1" />
            </tps-windowed-router-link>
            <tps-windowed-router-link data-testid="main-layout-nav-open-material-list" [url]="'/material'" [tabLabel]="i18n.translate('cam-master-db:dataTables')">
              <tps-navbar-button matIcon="table_view" [label]="i18n.translate('cam-master-db:dataTables')()" tabType="none" [indentation]="1" />
            </tps-windowed-router-link>
          }

          @if (state.planningExpanded()) {
            <tps-navbar-button (click)="state.planningExpanded.set(false)" matIcon="folder_open" [label]="i18n.translate('planningAndSteering')()" tabType="none" arrow="keyboard_arrow_down" />
          } @else {
            <tps-navbar-button (click)="state.planningExpanded.set(true)" matIcon="folder" [label]="i18n.translate('planningAndSteering')()" tabType="none" arrow="keyboard_arrow_left" />
          }
          @if (state.planningExpanded()) {
            <tps-navbar-button matIcon="timeline" [label]="i18n.translate('preplanning')()" tabType="none" [indentation]="1" disabled />
            <tps-navbar-button matIcon="view_timeline_filled" [label]="i18n.translate('fineplanning')()" tabType="none" [indentation]="1" disabled />
          }

          @if (state.logisticsExpanded()) {
            <tps-navbar-button (click)="state.logisticsExpanded.set(false)" matIcon="folder_open" [label]="i18n.translate('warehouseAndLogistics')()" tabType="none" arrow="keyboard_arrow_down" />
          } @else {
            <tps-navbar-button (click)="state.logisticsExpanded.set(true)" matIcon="folder" [label]="i18n.translate('warehouseAndLogistics')()" tabType="none" arrow="keyboard_arrow_left" />
          }
          @if (state.logisticsExpanded()) {
            <tps-navbar-button matIcon="warehouse" [label]="i18n.translate('warehouseTools')()" tabType="none" [indentation]="1" disabled />
            <tps-navbar-button matIcon="warehouse" [label]="i18n.translate('warehouseArticles')()" tabType="none" [indentation]="1" disabled />
          }

          <tps-navbar-button matIcon="check_circle" [label]="i18n.translate('qualityManagement')()" tabType="none" disabled />
          <tps-navbar-button matIcon="handyman" [label]="i18n.translate('toolManagement')()" tabType="none" disabled />
        }
      </nav>

      <tps-navbar-button data-testid="main-layout-nav-open-help" matIcon="help" [label]="i18n.translate('help')()" tabType="none" />
      <tps-navbar-button data-testid="main-layout-nav-open-settings" matIcon="settings" [label]="i18n.translate('settings')()" tabType="none" />
      <tps-navbar-button data-testid="main-layout-nav-open-profile-menu" matIcon="dashboard" [label]="displayedUserName()" [mat-menu-trigger-for]="profileMenu" tabType="none" />
      <tps-navbar-button data-testid="main-layout-nav-open-logout" (click)="logout()" matIcon="logout" [label]="i18n.translate('logout')()" tabType="none" />
      <mat-menu #profileMenu>

        <button mat-menu-item [matMenuTriggerFor]="userInfoMenu">
          <mat-icon>person</mat-icon>
        </button>

        <button mat-menu-item [matMenuTriggerFor]="languageMenu">
          <mat-icon>translate</mat-icon>
        </button>

        <mat-menu #languageMenu>
          <button mat-menu-item (click)="i18n.setLang('de')">Deutsch</button>
          <button mat-menu-item (click)="i18n.setLang('en')">English</button>
        </mat-menu>

        <mat-menu #userInfoMenu>
          <div mat-menu-item><mat-icon>people</mat-icon> {{ authService.tbsTeams().join(', ') }}</div>
          <div mat-menu-item><mat-icon>build</mat-icon> {{ authService.tbsCompanyRoles().join(', ') }}</div>
        </mat-menu>

      </mat-menu>

      <div class="nav-list">
        <p class="version-info">{{ versionInfo }}</p>
      </div>
    </div>

    <div class="window-content">
      <tps-window-context class="window-context" [windowIndex]="0" [tabIndex]="getTabIndex(0)()">
        <tps-feature-instance data-testid="main-layout-feature-instance" [urlPath]="getUrlComputed(0)()" />
      </tps-window-context>
      <!-- <div class="tab-dropzone-group" [class.active]="globalDraggedTab() !== null">
        <div class="tab-dropzone" style="width: 300px" cdkDropList [id]="windowZoneDropListIDs()[0]" [cdkDropListConnectedTo]="allDropListIDs()" (cdkDropListDropped)="onDrop($event, 0, 'before')"></div>
        <div class="tab-dropzone flex-grow-row" cdkDropList [id]="windowZoneDropListIDs()[1]" [cdkDropListConnectedTo]="allDropListIDs()" (cdkDropListDropped)="onDrop($event, 0, 'inside')"></div>
        <div class="tab-dropzone" style="width: 300px" cdkDropList [id]="windowZoneDropListIDs()[2]" [cdkDropListConnectedTo]="allDropListIDs()" (cdkDropListDropped)="onDrop($event, 0, 'after')"></div>
      </div> -->
    </div>
  </div>
</div>


@for (window of additionalWindows(); track window.id) {
  <div class="window-container">
    <div class="window-toolbar-padding">
      <div class="window-toolbar flex-grow-row" [id]="'window-toolbar-' + ($index + 1)">
        <tps-window-tabs [attr.data-testid]="'main-layout-window-tabs-' + ($index + 1)" [windowIndex]="($index + 1)" [dropListID]="windowTabsDropListIDs()[$index + 1]" [connectedDropLists]="allDropListIDs()" [id]="'window-tabs-' + ($index + 1)" [style]="tabBarLimits()[$index + 1] > 0 ? 'max-width: ' + tabBarLimits()[$index + 1] + 'px;' : ''" />
        <div class="flex-grow-row"></div>
      </div>
    </div>
    <div class="window-content">
      <tps-window-context [windowIndex]="($index + 1)" [tabIndex]="getTabIndex($index + 1)()">
        <tps-feature-instance [attr.data-testid]="'main-layout-feature-instance-' + ($index + 1)" [urlPath]="getUrlComputed($index + 1)()" />
      </tps-window-context>
      <!-- <div class="tab-dropzone-group" [class.active]="globalDraggedTab() !== null">
        <div class="tab-dropzone" style="width: 300px" cdkDropList [id]="windowZoneDropListIDs()[($index + 1) * 3]" [cdkDropListConnectedTo]="allDropListIDs()" (cdkDropListDropped)="onDrop($event, $index + 1, 'before')"></div>
        <div class="tab-dropzone flex-grow-row" cdkDropList [id]="windowZoneDropListIDs()[($index + 1) * 3 + 1]" [cdkDropListConnectedTo]="allDropListIDs()" (cdkDropListDropped)="onDrop($event, $index + 1, 'inside')"></div>
        <div class="tab-dropzone" style="width: 300px" cdkDropList [id]="windowZoneDropListIDs()[($index + 1) * 3 + 2]" [cdkDropListConnectedTo]="allDropListIDs()" (cdkDropListDropped)="onDrop($event, $index + 1, 'after')"></div>
      </div> -->
    </div>
  </div>
}

<div class="tool-corner" id="tool-corner">
  <ngt-link data-testid="main-layout-change-layout-to-flat-link" (click)="testing.layout.set('flat')" href="#" matIcon="open_in_new" target="">Flat Layout</ngt-link>
  <tps-copy-context-link data-testid="main-layout-copy-active-tab-link" [context]="activeTabsContext()" [title]="('windowtabs:shareAllActiveTabs' | translate)()" />
  @if (scrollable()) {
    @if (scrollSnapping()) {
      <ngt-button data-testid="main-layout-deactivate-scroll-snapping" (click)="scrollSnapping.set(false)" matIcon="view_carousel" shape="square" [styling]="'primary'" />
    } @else {
      <ngt-button data-testid="main-layout-activate-scroll-snapping" (click)="scrollSnapping.set(true)" matIcon="view_carousel" shape="square" [styling]="'muted'" />
    }
  }
  @if (windowCount() === 1 && tabCountWindow1() > 1) {
    <ngt-button data-testid="main-layout-add-compare-window" (click)="addCompareModeWindow()" shape="square" [styling]="'muted'" ><mat-icon style="transform: rotate(90deg);">splitscreen_landscape</mat-icon></ngt-button>
  }
  @if (windowCount() === 2) {
    <ngt-button data-testid="main-layout-remove-compare-window" (click)="removeCompareModeWindow()" matIcon="crop_landscape" shape="square" [styling]="'primary'" />
    <!-- <ngt-switch [name]="('sync' | translate)()" [(checked)]="state.syncWindows" /> -->
  }
  <img src="assets/images/assistant.png" alt="assistant" style="width: 56px; height: 56px;">
</div>
